import axios from 'axios';
import apiConfig from '../../api.config';
import constants from '../../../constants';
import storage from '../../../storage';

export default function getHotelContractList(hotelId) {
  const {
    host,
    URIs: { getHotelContractList },
  } = apiConfig;

  const uri = `${host}${getHotelContractList}`;

  const storedCredentials = JSON.parse(storage.get(constants.AUTH.USER_KEY));

  return axios
    .post(uri, {
      searchCriteria: {
        hotelId: hotelId || 0,
        hotelReference: 'civitfun',
        accessToken: storedCredentials.accessToken,
      }
    })
    .then(res => {
      return res.data;
    });
}
